export default __webpack_public_path__ + "static/media/post7.b21ad99a.jpg";